import { render, staticRenderFns } from "./NeedToC.vue?vue&type=template&id=fd0bda7e&"
import script from "./NeedToC.vue?vue&type=script&lang=js&"
export * from "./NeedToC.vue?vue&type=script&lang=js&"
import style0 from "./NeedToC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports